import React, { useEffect, useState } from 'react';

import {
  Row,
  Form,
  Input,
  Col,
  Tag,
  notification,
  Checkbox,
  Select,
  Switch
} from 'antd';
import {
  SubmitButton,
  SubmitButtonCol,
  PhoneNumberCol
} from '../styledComponents.js';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { NAME_REGEX_CHECK } from '../../../Constants/StringConstants.js';
import { StyledSelectFacility } from './styledComponents.js';
import CancelIcon from '../../../Assets/Icons/CancelIcon.js';
import { reviewerGroupsEachLevel } from '../../../Apis/Reviewer';
import { renderBillerAssignmentOptions } from '../Billers/billerAssignmentOptions';
const { Option } = Select;
const AddAdminForm = ({
  selectedItem,
  submitHandler,
  submitLoading,
  reviewerList,
  facilities,
  billersList,
  billerGroupsList
}) => {
  const [form] = Form.useForm();
  const [Updated, setUpdated] = useState({ phone: false, other: false });
  const [changedValues, setchangedValues] = useState();
  const [selectedReviewers, setSelectedReviewers] = useState([]);
  const reviewerLevel = Form.useWatch('reviewerLevel', form);

  const [reviewerLevel1, setReviewerLevel1] = useState(null);
  const [reviewerLevel1List, setReviewerLevel1List] = useState([]);
  const [reviewerLevel1GroupList, setReviewerLevel1GroupList] = useState(null);
  const [reviewerLevel2, setReviewerLevel2] = useState(null);
  const [reviewerLevel2List, setReviewerLevel2List] = useState([]);
  const [reviewerLevel2GroupList, setReviewerLevel2GroupList] = useState(null);

  const phoneNumberChanged = (value, country, e, formattedValue) => {
    let countryCode = country.dialCode;
    form.setFieldsValue({
      phoneNumber: {
        countryCode: countryCode
      }
    });
    let changedPHCode =
      String(selectedItem?.phoneNumber?.countryCode) !==
      String(country.dialCode);
    let changedPH =
      String(selectedItem?.phoneNumber?.number).slice(0, 11) !== String(value);

    setUpdated({ ...Updated, phone: changedPHCode || changedPH });
  };
  // const [selfReviewEnabled, setSelfReviewEnabled] = useState(
  //   selectedItem?.selfReviewEnabled ? selectedItem.selfReviewEnabled : false
  // );
  // const handleCheckboxChange = e => {
  //   setSelfReviewEnabled(e.target.checked);
  // };
  // const [activateRoster, setActivateRoster] = useState(
  //   selectedItem?.activateRoster ? selectedItem.activateRoster : false
  // );

  // const transcriptionFlowChange = changedValue => {
  //   if (changedValue === 'TRANSCRIPTION_ONLY') {
  //     form.setFieldsValue({ reviewerCount: '0' });

  // const handleReviewerChange = values => {
  //   console.log(values, 'values');

  //   if (values.includes('none') || values.includes('any')) {
  //     // If "None" or "Any" is selected, set only that value
  //     form.setFieldsValue({
  //       reviewerList: [values.find(val => val === 'none' || val === 'any')]
  //     });
  //   } else {
  //     // Otherwise, remove "None" and "Any" if other values are selected
  //     form.setFieldsValue({
  //       reviewerList: values.filter(val => val !== 'none' && val !== 'any')
  //     });
  //   }
  // };
  const handleReviewerLevelChange = async value => {
    // setReviewerLevel(value);
    form.setFieldValue('reviewerLevel', value);

    if (value !== 'none') {
    }

    setReviewerLevel1(null);
    setReviewerLevel2(null);
  };
  useEffect(() => {
    const fetchReviewerData = async () => {
      try {
        const [level1Response, level2Response] = await Promise.all([
          reviewerGroupsEachLevel('LEVEL_1'),
          reviewerGroupsEachLevel('LEVEL_2')
        ]);

        if (level1Response.data.success) {
          const result1 = level1Response.data.result?.[0] || {};
          setReviewerLevel1List(result1.reviewers || []);
          setReviewerLevel1GroupList(result1.reviewerGroups || []);
        } else {
          notification.error({
            message: 'Failed to load LEVEL_1 reviewers',
            description: level1Response.data.message
          });
        }

        if (level2Response.data.success) {
          const result2 = level2Response.data.result?.[0] || {};
          setReviewerLevel2List(result2.reviewers || []);
          setReviewerLevel2GroupList(result2.reviewerGroups || []);
        } else {
          notification.error({
            message: 'Failed to load LEVEL_2 reviewers',
            description: level2Response.data.message
          });
        }
      } catch (error) {
        console.error('Error fetching reviewers', error);
        notification.error({
          message: 'Error',
          description: 'Something went wrong while fetching reviewers'
        });
      }
    };

    fetchReviewerData();
  }, []);
  useEffect(() => {
    if (selectedItem) {
      const data = selectedItem;
      // data.reviewerList =
      //   (data.reviewerList && data.reviewerList.length === 0) ||
      //   data.reviewerList.includes('none') ||
      //   data.reviewerList.includes('any')
      //     ? data.isAnyReviewerSelected && data.isAnyReviewerSelected
      //       ? ['any']
      //       : ['none']
      //     : data.reviewerList.map(item => item.fullName);
      if (data.phoneNumber?.number) {
        data.phoneNumber.number = data.phoneNumber.countryCode.concat(
          data.phoneNumber.number
        );
      } else {
        data.phoneNumber = '';
      }
      data.facilityIds = data.facilities.map(item => item.facilityId);
      const ab = data.assignedBiller || {};
      data.billerConfig = {
        billers: ab.isAnySelected
          ? ['any']
          : [
              ...(ab.billers || []).map(b => b.id),
              ...(ab.billerGroups || []).map(g => `group_${g.id}`)
            ]
      };
      if (data.reviewerFlow) {
        const flow = data.reviewerFlow;

        // Map reviewerFlow -> reviewerLevel
        if (flow.reviewerFlow) {
          if (flow.reviewerFlow === 'LEVEL_1') {
            data.reviewerLevel = 'level_1';
          } else if (flow.reviewerFlow === 'LEVEL_2') {
            data.reviewerLevel = 'level_2';
          } else {
            data.reviewerLevel = 'none';
          }
        } else {
          data.reviewerLevel = 'none';
        }

        // Combine reviewers + groups for Level 1
        const reviewerIdsForLevel1 = flow.isAnySelectedForLevel1
          ? ['any']
          : (flow.reviewersForLevel1 || []).map(r => r.id);
        const groupIdsForLevel1 = (flow.reviewerGroupsForLevel1 || []).map(
          g => g.id
        );

        data.reviewerLevel1 = [...reviewerIdsForLevel1, ...groupIdsForLevel1];

        // Combine reviewers + groups for Level 2
        const reviewerIdsForLevel2 = flow.isAnySelectedForLevel2
          ? ['any']
          : (flow.reviewersForLevel2 || []).map(r => r.id);
        const groupIdsForLevel2 = (flow.reviewerGroupsForLevel2 || []).map(
          g => g.id
        );
        data.reviewerLevel2 = [...reviewerIdsForLevel2, ...groupIdsForLevel2];

        // ❌ Remove reviewerFlow from data (don't set it into form)
        delete data.reviewerFlow;
      }
      form.setFieldsValue({ ...data });
      setchangedValues({ ...data });
    }
    // eslint-disable-next-line
  }, [selectedItem]);
  const tagRender = props => {
    const { label, disabled, onClose } = props;
    const onPreventMouseDown = event => {
      event.preventDefault();
      event.stopPropagation();
    };

    return (
      <Tag
        className={`ant-select-selection-item ${
          disabled ? `disabled-facility-tag` : ``
        }`}
        onMouseDown={onPreventMouseDown}
        closable={true}
        onClose={onClose}
        closeIcon={
          <div className='ant-select-selection-item-remove'>
            <CancelIcon height={12} width={12} />
          </div>
        }
      >
        <p className='ant-select-selection-item-label'>{label}</p>
      </Tag>
    );
  };

  const billerTagRender = props => {
    const { label, onClose } = props;
    const onPreventMouseDown = event => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable={true}
        onClose={onClose}
        style={{
          marginRight: 3,
          fontSize: 14,
          lineHeight: '28px',
          padding: '0 8px'
        }}
      >
        {label}
      </Tag>
    );
  };

  const onvalueUpdate = values => {
    if (!Boolean(values?.phoneNumber)) {
      setchangedValues({ ...changedValues, ...values });
      setUpdated({
        ...Updated,
        other:
          JSON.stringify({ ...changedValues, ...values }) !==
          JSON.stringify(selectedItem)
      });
    }
  };
  return (
    <Form
      form={form}
      layout='vertical'
      onFinish={values => {
        const {
          billerConfig: rawBillerConfig,
          biller: _biller,
          ...restValues
        } = values;
        const allSelected = rawBillerConfig?.billers || [];
        const billerConfig = allSelected.includes('any')
          ? { billers: ['any'], billerGroups: [] }
          : {
              billers: allSelected.filter(v => !String(v).startsWith('group_')),
              billerGroups: allSelected
                .filter(v => String(v).startsWith('group_'))
                .map(v => v.replace('group_', ''))
            };
        const reviewerFlowConfig = {
          reviewerFlow: values.reviewerLevel?.toUpperCase() || 'NONE', // Use form value

          // Process reviewerLevel1 - Filter groups and reviewers
          reviewerGroupsForLevel1:
            (form.getFieldValue('reviewerLevel1') || [])[0] === 'any'
              ? ['any']
              : (form.getFieldValue('reviewerLevel1') || [])
                  .map(item => {
                    const group = reviewerLevel1GroupList.find(
                      g => g.id === item
                    ); // Filter from the groups list
                    return group ? group.id : null;
                  })
                  .filter(Boolean), // Remove null values

          reviewersForLevel1: (form.getFieldValue('reviewerLevel1') || [])
            .map(item => {
              const reviewer = reviewerLevel1List.find(r => r.id === item); // Filter from the reviewers list
              return reviewer ? reviewer.id : null;
            })
            .filter(Boolean), // Remove null values

          // Process reviewerLevel2 - Filter groups and reviewers
          reviewerGroupsForLevel2:
            (form.getFieldValue('reviewerLevel2') || [])[0] === 'any'
              ? ['any']
              : (form.getFieldValue('reviewerLevel2') || [])
                  .map(item => {
                    const group = reviewerLevel2GroupList.find(
                      g => g.id === item
                    ); // Filter from the groups list
                    return group ? group.id : null;
                  })
                  .filter(Boolean), // Remove null values

          reviewersForLevel2: (form.getFieldValue('reviewerLevel2') || [])
            .map(item => {
              const reviewer = reviewerLevel2List.find(r => r.id === item); // Filter from the reviewers list
              return reviewer ? reviewer.id : null;
            })
            .filter(Boolean) // Remove null values
        };

        const {
          reviewerLevel,
          reviewerLevel1,
          reviewerLevel2,
          ...otherValues
        } = restValues;

        const finalPayload = {
          ...otherValues,
          reviewerFlowConfig,
          billerConfig
        };

        submitHandler(finalPayload);
      }}
      // onFinish={values => submitHandler(values)}
      onValuesChange={values => onvalueUpdate(values)}
    >
      <Row justify='center'>
        <Col span={24}>
          <Form.Item
            label='First Name'
            name='firstName'
            rules={[
              { required: true, message: 'First Name is required' },
              {
                pattern: new RegExp(NAME_REGEX_CHECK),
                message: 'Please enter only letters'
              }
            ]}
          >
            <Input size='large' />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label='Last Name'
            name='lastName'
            rules={[
              { required: true, message: 'Last Name is required' },
              {
                pattern: new RegExp(NAME_REGEX_CHECK),
                message: 'Please enter only letters'
              }
            ]}
          >
            <Input size='large' />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label='Facility'
            name='facilityIds'
            rules={[{ required: true, message: 'Facility is required' }]}
          >
            <StyledSelectFacility
              size='large'
              mode='multiple'
              showArrow
              options={facilities}
              optionFilterProp='label'
              getPopupContainer={trigger => trigger.parentNode}
              tagRender={tagRender}
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label='Email'
            name='email'
            rules={[
              { required: true, message: 'Email is required' },
              {
                type: 'email',
                message: 'Please enter valid email'
              }
            ]}
          >
            <Input size='large' />
          </Form.Item>
        </Col>
        <PhoneNumberCol span={24}>
          <Form.Item noStyle>
            <Form.Item
              name={['phoneNumber', 'countryCode']}
              noStyle
            ></Form.Item>
            <Form.Item
              label='Phone Number'
              name={['phoneNumber', 'number']}
              rules={[{ required: true, message: 'Phone Number is required' }]}
            >
              <PhoneInput country={'us'} onChange={phoneNumberChanged} />
            </Form.Item>
          </Form.Item>
        </PhoneNumberCol>

        <Col span={24}>
          <Form.Item label='Reviewer Level' name='reviewerLevel'>
            <Select
              size='large'
              value={reviewerLevel}
              onChange={handleReviewerLevelChange}
            >
              <Option value='none'>None</Option>
              <Option value='level_1'>Reviewer Level 1</Option>
              <Option value='level_2'>Reviewer Level 2</Option>
            </Select>
          </Form.Item>
        </Col>

        {/* {(reviewerLevel === 'level1' || reviewerLevel === 'level2') && (
                  <Col span={24}>
                    <Form.Item label='Reviewer Level 1' name='reviewerLevel1'>
                      <Select
                        size='large'
                        value={reviewerLevel1}
                        onChange={value => setReviewerLevel1(value)}
                      >
                        <Option value='any'>Any</Option>
                        <Option value='none'>None</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                )} */}
        {reviewerLevel && ['level_1', 'level_2'].includes(reviewerLevel) && (
          <Col span={24}>
            <Form.Item label='Reviewer Level 1' name='reviewerLevel1'>
              <Select
                size='large'
                mode='multiple'
                value={reviewerLevel1}
                // onChange={value => setReviewerLevel1(value)}
                onChange={value => {
                  setReviewerLevel1(value); // still set the full value
                  // console.log('valujke', value);

                  // // Now separate into two lists:
                  // const selectedReviewerList = reviewerLevel1List.filter(item =>
                  //   value.includes(item.id)
                  // );
                  // const selectedReviewerGroupList =
                  //   reviewerLevel1GroupList.filter(item =>
                  //     value.includes(item.id)
                  //   );

                  // setSelectedReviewerList1(selectedReviewerList); // <-- you need to define this state
                  // setSelectedReviewerGroupList1(selectedReviewerGroupList); // <-- define this state too
                }}
              >
                <Option value='any'>Any</Option>

                {(reviewerLevel1List || []).map(item => (
                  <Option key={item.id} value={item.id}>
                    {item.fullName}
                  </Option>
                ))}

                {(reviewerLevel1GroupList || []).map(item => (
                  <Option key={item.id} value={item.id}>
                    {item.groupName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}

        {reviewerLevel && ['level_2'].includes(reviewerLevel) && (
          <Col span={24}>
            <Form.Item label='Reviewer Level 2' name='reviewerLevel2'>
              <Select
                size='large'
                mode='multiple'
                value={reviewerLevel2}
                onChange={value => {
                  setReviewerLevel2(value); // still set the full value

                  // Now separate into two lists:
                  // const selectedReviewerList = reviewerLevel2List.filter(item =>
                  //   value.includes(item.id)
                  // );
                  // const selectedReviewerGroupList =
                  //   reviewerLevel2GroupList.filter(item =>
                  //     value.includes(item.id)
                  //   );

                  // setSelectedReviewerList2(selectedReviewerList); // <-- you need to define this state
                  // setSelectedReviewerGroupList2(selectedReviewerGroupList); // <-- define this state too
                }}
              >
                <Option value='any'>Any</Option>

                {(reviewerLevel2List || []).map(item => (
                  <Option key={item.id} value={item.id}>
                    {item.fullName}
                  </Option>
                ))}

                {(reviewerLevel2GroupList || []).map(item => (
                  <Option key={item.id} value={item.id}>
                    {item.groupName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}
        <Col span={24}>
          <Form.Item label='Billers' name={['billerConfig', 'billers']}>
            <Select size='large' mode='multiple' placeholder='Select billers' optionFilterProp='children' showSearch allowClear getPopupContainer={trigger => trigger.parentNode} tagRender={billerTagRender}>
              <Select.Option value='any'>Any</Select.Option>
              {renderBillerAssignmentOptions(billersList, billerGroupsList)}
            </Select>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label='Default Copy Forward Source' name='defaultProgressNoteSelection'>
            <Select size='large' getPopupContainer={trigger => trigger.parentNode}>
              <Option value='FROM_CLINIC_NOTES'>Clinic</Option>
              <Option value='FROM_MY_NOTES'>Provider</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name='sortDiagnosisByNta' valuePropName='checked'>
            <Checkbox>Sort diagnosis by NTA</Checkbox>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name='isFacilityAccessAllowed'
            valuePropName='checked'
            initialValue={selectedItem?.isFacilityAccessEnabled}
          >
            <Checkbox>Facility Access</Checkbox>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label='Biller Admin' name='billerAdmin' valuePropName='checked'>
            <Switch />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <SubmitButtonCol span={24}>
          <SubmitButton
            htmlType='submit'
            type='primary'
            size='large'
            shape='round'
            disabled={
              !(Updated.phone || Updated.other) && Boolean(selectedItem)
            }
            loading={submitLoading}
          >
            Submit
          </SubmitButton>
        </SubmitButtonCol>
      </Row>
    </Form>
  );
};

export default AddAdminForm;
